import { ControleQuinquennalApi } from "@src/data/controle-quinquennal/controle-quinquennal.api";
import { controleQuinquennalKeys } from "@src/data/controle-quinquennal/hook/controle-quinquennal.keys";
import { useQuery } from "@tanstack/react-query";

export const useCQConversationQuery = (
  idCq: string,
  idAxe: string,
  axeName: string
) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.conversationsByAxes(idAxe),
    queryFn: () =>
      ControleQuinquennalApi.getCQConversation(idCq, idAxe, axeName),
    staleTime: Infinity,
  });
};
